type Props = {
  children: number;
};

export default function CommaFormattedNumber({ children }: Props) {
  return <>{Number(children).toLocaleString('ja-JP')}</>;
}
